import Reveal from '@/components/base/Reveal';
import { hotBoard, hotBoardStats } from '@/mocks/homeData';

function HotBoard() {
  return (
    <section id="hotboard" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl">
          <Reveal>
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center w-10 h-10 rounded-md bg-primary-500 text-background-50 text-xl">
                <i className="ri-fire-line" />
              </span>
              <div>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">今日热榜</h2>
                <p className="mt-1 text-sm text-foreground-600 font-label">全站条目按实时热度排序，每天滚动更新。</p>
              </div>
            </div>
          </Reveal>

          <div className="mt-9 grid grid-cols-1 lg:grid-cols-[1fr_300px] gap-5">
            <div className="rounded-lg border border-background-200 overflow-hidden">
              {hotBoard.map((item, index) => (
                <Reveal key={item.rank} delay={index * 30}>
                  <a
                    href="#latest"
                    className="group flex items-center gap-4 px-4 md:px-5 py-4 border-b border-background-200 last:border-b-0 hover:bg-background-100 transition-colors"
                  >
                    <span
                      className={`flex items-center justify-center w-8 h-8 rounded-md font-heading font-bold text-sm shrink-0 ${
                        index < 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm md:text-[15px] font-label text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                        {item.title}
                      </p>
                      <span className="mt-1 inline-flex items-center h-5 px-2 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-label">
                        {item.district}
                      </span>
                    </div>
                    <span className="hidden sm:flex items-center gap-1 text-xs font-label text-foreground-500 shrink-0">
                      <i className="ri-pulse-line text-primary-500" />
                      {item.heat}
                    </span>
                  </a>
                </Reveal>
              ))}
            </div>

            <Reveal delay={120} className="h-full">
              <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5 flex flex-col">
                <h3 className="font-heading text-lg font-bold text-foreground-950">榜单速览</h3>
                <p className="mt-1 text-xs font-label text-foreground-600">过去 24 小时的活跃情况</p>

                <div className="mt-5 space-y-4">
                  {hotBoardStats.map((stat) => (
                    <div key={stat.label} className="flex items-end justify-between border-b border-background-200 pb-3 last:border-b-0">
                      <span className="text-sm font-label text-foreground-600">{stat.label}</span>
                      <span className="font-heading text-2xl font-bold text-foreground-950">{stat.value}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-auto pt-5">
                  <div className="rounded-md bg-accent-100 p-4">
                    <span className="inline-flex items-center gap-1 text-[11px] font-label text-accent-900">
                      <i className="ri-lightbulb-flash-line" />
                      提示
                    </span>
                    <p className="mt-2 text-xs font-label text-accent-950 leading-relaxed">
                      热榜只显示条目索引，点进去就能看到对应分区与子版主页入口。
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HotBoard;